import { ia } from 'lib/helpers/utility';

// "Completed", "Completed +3", or a count ("4 statuses") while the picked values have no labels
// yet (restored from the URL before their options load). `pluralLabel` is only a string when
// there are values, so it is read only then.
export const chipValueText = (values, pluralLabel) => {
  const [item] = (ia(values) && values) || [];
  if (!ia(values)) return item?.label;
  if (!item?.label) return `${values.length} ${String(pluralLabel).toLowerCase()}`;
  return ia(values, 1) ? `${item.label} +${values.length - 1}` : item.label;
};
